export const permissions = {
  view: 'reporting.view_reportinggroup',
  add: 'reporting.add_reportinggroup',
  change: 'reporting.change_reportinggroup',
  delete: 'reporting.delete_reportinggroup',
};
